import { render, staticRenderFns } from "./TaxRatesNewModal.vue?vue&type=template&id=1a91a97a&"
import script from "./TaxRatesNewModal.vue?vue&type=script&lang=js&"
export * from "./TaxRatesNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports